// Shared helpers for the Partner home: filter definitions and predicates, date
// and name formatting. The predicates mirror services/partner_overview.py so the
// tile counts (computed server-side) and the filtered rows always agree.

export const FILTERS = [
  { key: 'all', label: 'All clients' },
  { key: 'login', label: 'Not logged in' },
  { key: 'profile', label: 'Profile under 60%' },
  { key: 'contract', label: 'Contracts ending' },
  { key: 'payment', label: 'Payment issues' },
];

export const ENDING_DAYS = 30;
// Mirrors PROFILE_LOW_PCT in backend/app/services/partner_overview.py.
export const PROFILE_LOW_PCT = 60;

export function endsSoon(iso, now = new Date()) {
  if (!iso) return false;
  const end = new Date(iso);
  if (Number.isNaN(end.getTime())) return false;
  return end >= now && end <= new Date(now.getTime() + ENDING_DAYS * 86400000);
}

export function matchesFilter(row, key, now = new Date()) {
  switch (key) {
    case 'login': return row.login_count === 0;
    case 'profile': return row.profile_pct < PROFILE_LOW_PCT;
    case 'contract': return endsSoon(row.concierge_expires_at, now);
    case 'payment': return row.plan_status === 'due';
    default: return true;
  }
}

// A bare DATE-ONLY string ("2026-10-01") parses as UTC midnight and renders as
// the previous day in every US timezone, so build it from its parts. Datetimes
// parse as local time. Missing or unparseable values fall back to an em dash.
export function fmtDate(iso) {
  if (!iso) return '—';
  const dateOnly = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  const d = dateOnly
    ? new Date(Number(dateOnly[1]), Number(dateOnly[2]) - 1, Number(dateOnly[3]))
    : new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}

export function initials(name) {
  const parts = (name || '').trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '?';
  return (parts[0][0] + (parts.length > 1 ? parts[parts.length - 1][0] : '')).toUpperCase();
}

export function greeting(date = new Date()) {
  const h = date.getHours();
  return h < 12 ? 'Good morning' : h < 18 ? 'Good afternoon' : 'Good evening';
}

// Newest profile edit first, never-edited last; ties (and the never-edited) by name.
export function sortByLastEdit(rows) {
  const t = (r) => (r.last_profile_change_at ? new Date(r.last_profile_change_at).getTime() : -Infinity);
  const nm = (r) => (r.name || '').toLowerCase();
  return [...rows].sort((a, b) => {
    const d = t(b) - t(a);
    if (d !== 0 && !Number.isNaN(d)) return d;
    return nm(a).localeCompare(nm(b));
  });
}
